<template>
  <div v-if="step == 'practiceComplete'">
    <div class="tw-mt-[50px]">
      Congratulations you completed this activity. You can choose to practice
      the words again or test yourself.
    </div>
    <div class="tw-text-main1">
      {{ spellingPoints }} points would have been sent to your account if you
      were logged in.
    </div>
    <div>
      <button class="sf-btn-primary" @click.prevent="$emit('close')">
        Close
      </button>
    </div>
  </div>
  <div v-else-if="step == 'nameForm'">
    <div class="tw-mt-[50px]">
      You have completed your test. Please enter your name.
    </div>
    <form @submit.prevent="setName">
      <div v-if="isMobile">
        {{ customName }}
      </div>
      <div v-else>
        <input
          ref="setNameField"
          v-model="customName"
          type="text"
          class="tw-border tw-border-solid tw-border-primary tw-p-[10px] tw-py-[10px] tw-my-[20px] tw-outline-none"
        />
      </div>
      <div v-if="customNameError" class="tw-text-danger">
        Please enter a valid name
      </div>
      <div>
        <button class="sf-btn-primary" type="submit">Set Name</button>
      </div>
      <div class="tw-text-main1">
        {{ spellingPoints }} points would have been sent to your account if you
        were logged in.
      </div>
      <MobileKeyboard v-if="isMobile" v-model="customName" />
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import isMobileDevice from "@/func/general/isMobileDevice";
import MobileKeyboard from "./MobileKeyboard.vue";
import { SfActivityMode, SfActivitySaveData } from "@/types/sfActivityTypes";
import { spellingActivitySaveData } from "@/state/spellingGameState";

export default defineComponent({
  components: { MobileKeyboard },
  emits: ["nameSet", "close"],
  data() {
    return {
      step: "",
      customName: "",
      customNameError: false,
      isMobile: false,
    };
  },
  computed: {
    saveData(): SfActivitySaveData | null {
      return spellingActivitySaveData.value;
    },
    mode(): SfActivityMode {
      return spellingActivitySaveData.value
        ? spellingActivitySaveData.value.mode
        : "test";
    },
    spellingPoints(): number {
      return spellingActivitySaveData.value
        ? spellingActivitySaveData.value.sfPoints
        : 0;
    },
  },
  mounted() {
    this.isMobile = isMobileDevice();
    if (this.mode == "test") {
      this.step = "nameForm";
      if (!this.isMobile) {
        this.$nextTick(() => {
          (this.$refs.setNameField as HTMLElement).focus();
        });
      }
    } else {
      this.step = "practiceComplete";
    }
  },
  methods: {
    setName() {
      this.customNameError = false;
      if (this.customName.trim().length < 1) {
        this.customNameError = true;
        return;
      }
      this.$emit("nameSet", this.customName);
    },
  },
});
</script>
